import { Component, OnInit } from '@angular/core';
import { trigger, transition, animate, style, state } from '@angular/animations';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CommonService } from 'src/shared/common/common.service';
import { LoginEntity } from 'src/shared/models/loginResponse.model';
import { AuthenticationService } from 'src/shared/services/auth.service';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, Observable, ReplaySubject, Subscription, interval } from "rxjs";
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { GeneralMasterService } from 'src/shared/services/general-master.service';
import { ToastService } from 'src/shared/toastr';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        backgroundColor: '#eeeeee'
      })),
      state('closed', style({
        height: 0,
        opacity: 0,
        backgroundColor: 'transparent'
      })),
      transition('open => closed', [
        animate('2s')
      ]),
      transition('closed => open', [
        animate('2s')
      ]),
    ]),
  ]
})
export class HeaderComponent implements OnInit {
  public showSearchListBlock: boolean = true;
  public isOpen = false;
  public menuList = [];
  public cloneMenuList = [];
  public companyName: string;
  public companyShortName: string;
  public imageURL = '/assets/images/avatar.jpg';
  public companyLogo: SafeUrl;
  public offsetWidth = document.body.offsetWidth;
  public userName: string;

  private resizeObservable$: Observable<Event>;
  private resizeSubscription$: Subscription;
  private notificationSubscription$: Subscription;
  private destroySubscription$: ReplaySubject<any> = new ReplaySubject<any>(1);
  public showNotificationBlock = false;
  public notificationList$: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  constructor(
    private authService: AuthenticationService,
    private _sanitizer: DomSanitizer,
    private commonService: CommonService,
    private router: Router,
    private masterService: GeneralMasterService,
    private toastrService: ToastService,
  ) { }

  ngOnInit(): void {
    // const notificationCountLimit = localStorage.getItem('notificationCountLimit');
    // const notificationIntervalSource = interval(60000 * 5);
    // this.trackNotification(Number(notificationCountLimit));
    // this.notificationSubscription$ = notificationIntervalSource.subscribe(() => this.trackNotification(Number(notificationCountLimit)))
    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe((evt: any) => {
      this.offsetWidth = evt.target.innerWidth;
    })
    const getLoggedinUserDetail: LoginEntity = this.authService.currentUserValue;
    this.companyName = getLoggedinUserDetail.responseList[0].companyName;
    this.companyShortName = getLoggedinUserDetail.responseList[0].companyName.split(' ').map(x => x[0]).join('');
    this.companyLogo = this._sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + getLoggedinUserDetail.responseList[0].companyLogo);
    this.userName = getLoggedinUserDetail.responseList[0].employeeName;
    this.menuList = this.extractSubMenuFromMenuList(this.authService.menuList);
    const sortedMenuList = this.menuList.sort((prev, next) => prev.menuName.localeCompare(next.menuName));
    this.cloneMenuList = this.commonService.MutateArray(sortedMenuList);
  }

  ngOnDestroy() {
    this.notificationSubscription$ && this.notificationSubscription$.unsubscribe();
    this.resizeSubscription$ && this.resizeSubscription$.unsubscribe();
    this.destroySubscription$.next(null);
    this.destroySubscription$.complete();
  }

  extractSubMenuFromMenuList(objArray) {
    const subMenuList = [];
    objArray.forEach(menu => {
      menu.subMenu.forEach(submenu => {
        subMenuList.push({ menuName: submenu.menuName, url: submenu.url })
      })
    });
    return subMenuList;
  }

  navigateToDashboard() {
    this.router.navigate(['./'])
  }

  onKeyUpForSearching(searchValue: string) {
    searchValue = searchValue.toLowerCase();
    var tempMenuList = this.commonService.MutateArray(this.menuList);
    this.cloneMenuList = tempMenuList.filter((menu: any) => {
      if (!searchValue || menu.menuName.toLowerCase().indexOf(searchValue) !== -1) {
        return menu
      }
    });
  }

  closeCancelButton(event) {
    this.onKeyUpForSearching('');
  }

  redirectToSelectedMenu(selectedMenuURL) {
    this.isOpen = false;
    this.onKeyUpForSearching('');
    this.router.navigateByUrl(selectedMenuURL)
  }

  changePassword() {
    alert('in progress');
  }

  logout() {
    this.authService.logout();
  }

  trackAllNotification() {
    // this.notificationList$.next([])
    // this.trackNotification(-1)
  }

  readAllMessages() {
    // clear all message
    const payload = {
      genericManipulationRequestEntity: {
        entityID: null,
        createdBy: this.authService.employeeID,
        companyID: this.authService.companyID,
      }
    }
    this.masterService.requestApiForNotificationManagement(payload, 'dashboardservice/updateNotification')
      .pipe(takeUntil(this.destroySubscription$))
      .subscribe((records: any) => {
        if (records.statusCode === "200") {
          this.notificationList$.next([]);
        } else {
          this.toastrService.show({ type: 'error', text: records.errorMessage });
        }
      }, (error: HttpErrorResponse) => {
        this.toastrService.show({ type: 'error', text: 'Either Internet is not working or some internal server issue' });
      })
  }

  trackNotification(showNotificationCount: Number) {
    const payload = {
      genericManipulationRequestEntity: {
        entityBusinessID: this.authService.employeeID,
        companyID: this.authService.companyID,
        entityID: showNotificationCount
      }
    }
    this.masterService.requestApiForNotificationManagement(payload, 'dashboardservice/getAllNotifications')
      .pipe(takeUntil(this.destroySubscription$))
      .subscribe((records: any) => {
        if (records.statusCode === "200" || records.statusCode === "300") {
          records.responseList = records.responseList === null ? [] : records.responseList;
          this.notificationList$.next(records.responseList)
        } else {
          this.toastrService.show({ type: 'error', text: records.errorMessage });
        }
      }, (error: HttpErrorResponse) => {
        this.toastrService.show({ type: 'error', text: 'Either Internet is not working or some internal server issue' });
      })
  }

  onClickOfNotification(notification, index) {
    const payload = {
      genericManipulationRequestEntity: {
        entityID: notification.entityID,
        createdBy: this.authService.employeeID,
        companyID: this.authService.companyID,
      }
    }
    this.masterService.requestApiForNotificationManagement(payload, 'dashboardservice/updateNotification')
      .pipe(takeUntil(this.destroySubscription$))
      .subscribe((records: any) => {
        if (records.statusCode === "200") {
          const currentNotificationList = this.notificationList$.getValue();
          currentNotificationList.splice(index, 1);
          this.notificationList$.next(currentNotificationList);
        } else {
          this.toastrService.show({ type: 'error', text: records.errorMessage });
        }
      }, (error: HttpErrorResponse) => {
        this.toastrService.show({ type: 'error', text: 'Either Internet is not working or some internal server issue' });
      })
  }


}
